import { InputNumberProps, InputProps } from "antd";
import { CheckboxProps } from "antd/lib";

export const mc2Input: InputProps = {
  allowClear: true,
  style: { width: "100%" },
  size: "middle",
};

export const mc2Number: InputNumberProps = {
  style: { width: "100%" },
  size: "middle",
  min: 0,
};

export const mc2Checkbox: CheckboxProps = {};
